import React from 'react';

import classNames from 'classnames';

import {IDataInfoProps} from './../data-info';
import {Heat, IHeatProps} from './../heat';
import {ITableCellProps, ITableProps, ITableRowProps, Table, TTableCell} from './../table';

export interface IHeatmapProps extends Omit<ITableProps, 'rows'> {
    rows: IHeatmapRowProps[] | IDataInfoProps;
    className?: string;
}

export interface IHeatmapRowProps extends Omit<ITableRowProps, 'cells'> {
    cells: IHeatmapCellProps[];
}

export interface IHeatmapCellProps extends Omit<ITableCellProps, 'content'> {
    content: TTableCell | IHeatProps;
}

const Heatmap = (props: IHeatmapProps): JSX.Element => {
    const className: string = classNames(
        'heatmap',
        props.className,
    );

    const isHeat = (content: IHeatProps | TTableCell): content is IHeatProps => (content as IHeatProps).level !== undefined;
    const hasData = (data: IHeatmapRowProps[] | IDataInfoProps): data is IHeatmapRowProps[] => (data as IHeatmapRowProps[]).length > 0;

    const getTableRow = (row: IHeatmapRowProps): ITableRowProps => {
        const subRows: ITableRowProps[] | undefined = row.subRows ?
            row.subRows.map((subRow: IHeatmapRowProps) => (
                getTableRow(subRow)
            ))
            : undefined;

        return {
            ...row,
            cells: row.cells.map((cell: IHeatmapCellProps) => (
                {
                    ...cell,
                    content: isHeat(cell.content) ? (
                        <Heat {...cell.content} />
                    ) : cell.content,
                }
            )),
            subRows,
        };
    };

    const tableProps: ITableProps = {
        ...props,
        rows: hasData(props.rows) ? props.rows.map((row: IHeatmapRowProps) => (
            getTableRow(row)
        )) : props.rows,
    };

    return <div className={'scroll-fade__inner'}><Table {...tableProps} className={className}/> </div>;
};

export default Heatmap;
